<template>
  <div>
    <Modal v-model="model"  :mask-closable="false" width="90%" title="结算信息">
    <div slot="close">
        <!-- <Button @click="close()" class="close-btn">关闭</Button> -->
        <Icon type="md-close" @click="close()" size=20 style="margin-top:5px;" />
      </div>
      <Card dis-hover style="min-height:400px;">
        <Form ref="queryForm" :label-width="80" label-position="left" inline>
			<FormItem label="受理部门：" prop="acceptanceDept">
			  <Input type="text" placeholder="" v-model="query.acceptanceDept" style="width: 260px"></Input>
			</FormItem>
		  <FormItem label="结算方式:">
		    <Select v-model="query.settlementMethods" style="width: 160px">
		      <Option value=""> -- </Option>
		      <Option :value="product.value" v-for="(product,index) in settlementMethodData" :key="index">{{product.name}}</Option>
		    </Select>
		  </FormItem>
          <FormItem label="创建时间:">
            <DatePicker v-model="query.createTime" type="daterange" @on-change="dateChange" style="width: 260px" placement="bottom-end" placeholder="请选择"></DatePicker>
          </FormItem>
          <FormItem :label-width="20">
            <Button icon="ios-search" type="primary" size="default" @click="getpage(1)" class="toolbar-btn">查询</Button>
            <Button icon="md-refresh" type="primary" size="default" @click="reset" class="toolbar-btn">重置</Button>
            <Button icon="md-add" type="primary" size="default" @click="openCreateLog" class="toolbar-btn" v-if="!isDisable">新增</Button>
          </FormItem>
          <!-- </Row> -->
        </Form>
        <div>
          <Table :loading="loading" :columns="columns" no-data-text="暂无数据" border :data="list"></Table>
          <Page show-sizer show-total class-name="fengpage" :total="totalCount" class="margin-top-10" @on-change="pageChange" @on-page-size-change="pagesizeChange" :page-size="pageSize" :current="currentPage"></Page>
        </div>
      </Card>
      <div slot="footer">
        <Button @click="close()" class="close-btn">关闭</Button>
      </div>
    </Modal>
    <div v-if="createLogModelShow">
      <createSettlement :show="createLogModelShow" @close="closeModel" :customerId="customerId" :quotationId="quotationId" :isDetail="isDetail"></createSettlement>
    </div>
  </div>
</template>
<script>
import Util from '../../../lib/util'
import Ajax from '../../../lib/ajax'
import selectTree from '../../../components/selectTree/selectTree.vue'
import createSettlement from './createSettlement.vue'
export default {
  components: { createSettlement,selectTree },
  props: {
    show: Boolean,
    customerId: Number,
	isDetail:Boolean
  },
  data() {
    return {
      model: true,
      query: {
        createTime: [],
        acceptanceDept: null,
		settlementMethods:null,
        createTimeStart: '',
        createTimeEnd: '',
        customerId: this.customerId,
      },
      header: {
        Authorization: `Bearer ${Util.abp.auth.getToken()}`,
      },
	  isDisable:false,
      columns: [], //项目表头
      list: [], //项目数据
      settlementMethodData:[],
	  treeData:[],
      pageSize: 10,
	  quotationId:null,
      currentPage: 1,
      totalCount: 0,
      loading: false,
      createLogModelShow: false,
    }
  },
  mounted() {
	this.getSelect()
    this.getColumns()
    this.getpage(1)
	if(this.isDetail)
		this.isDisable=this.isDetail
  },
  methods: {
	  //   获取下拉框数据
	  async getSelect() {
	    const { data } = await this.$Ajax.get(
	      `/api/services/app/CustomerSettlementApiService/GetSettlementMgrInitData?customerId=${this.customerId}`
	    )
	    this.contactsData = data.result.contactsData
	    this.settlementMethodData = data.result.settlementMethodData
	    this.getTree()
	    this.spinShow = false
	  },
	  async getTree(){
	  		  let reponse=await Ajax.get('/api/services/app/OrganizationUnit/GetOrganizationUnitTree');
	  		  // reponse.data.result[0].expand = true;
	  		  let dataResult = reponse.data.result;
	  		  console.log(dataResult);
	  	// let respone = this.$store.state.department.departmentTree;
	  	this.editeTreeValue(dataResult);
	  	this.treeData = dataResult; 
	  },
	  selectChange(data){
	  	this.query.acceptanceDept = data
	  },
	  removeRoot(data){
	  	this.query.acceptanceDept = data
	  },
	  editeTreeValue(data){
	  	for (let i=0; i<data.length; i++) {
	  		data[i].title = data[i].displayName
	  		data[i].value = data[i].id
	  		if(data[i].children){
	  			if(data[i].children.length>0){
	  			   data[i].expand=true
	  			}
	  			this.editeTreeValue(data[i].children)
	  		}
	  	}
	  },
    getColumns() {
      this.columns = [
        {
          title: '受理部门',
          key: 'acceptanceDept',
          toolbar:true,
        },
        {
          title: '联系人',
          key: 'contactsIdsText',
        },
		{
          title: '结算方式',
          key: 'settlementMethodText',
        },
        {
          title: '创建时间',
		  width: 230,
          key: 'creationTimeText',
        },
        {
        
          title: '操作',
          width: 200,
          fixed: 'right',
          render: (h, params) => {
            return h('div', [
				h(
				  'Button',
				  {
				    props: {
				      type: 'primary',
				      size: 'small',
				    },
				    style: {
				      marginRight: '5px',
				      display: this.isDisable ? '' : 'none',
				    },
				    on: {
				      click: () => {
				        this.openCreateProduct(params.row.id)
				      },
				    },
				  },
				  '详情'
				),	
				h(
				  'Button',
				  {
				    props: {
				      type: 'primary',
				      size: 'small',
				    },
				    style: {
				      marginRight: '5px',
				      display: this.isDisable ? 'none' : '',
				    },
				    on: {
				      click: () => {
				        this.openCreateProduct(params.row.id)
				      },
				    },
				  },
				  '编辑'
				),
              h(
                'Button',
                {
                  props: {
                    type: 'error',
                    size: 'small',
                  },
				  style: {
				      marginRight: '5px',
					  display: this.isDisable ? 'none' : '',
				  },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: '确认删除这条记录吗？',
                        okText: '确认',
                        cancelText: '取消',
                        onOk: async () => {
                          const { data } = await this.$Ajax.delete(
                            `/api/services/app/CustomerSettlementApiService/Delete?id=${params.row.id}`
                          )
                          if (data.success) {
                            this.$Message.success({ content: '删除成功', duration: 5 })
                          } else {
                            this.$Message.error({ content: '删除失败', duration: 5 })
                          }
                          this.getpage()
                        },
                      })
                    },
                  },
                },
                '删除'
              ),
          
          
             
            ])
          },
        },
       
      ]
    },
    // 关闭弹窗
    close(refresh) {
      this.$emit('close', refresh)
    },
    closeModel(refresh) {
      this.createLogModelShow = false
      this.quotationId=0
	  if(refresh){
        this.getpage(1)
      }
    },
    //新增日志
    openCreateLog() {
      this.createLogModelShow = true
    },
    //时间改变
    dateChange() {
      let time = this.query.createTime
      let start = time[0] ? this.$moment(time[0]).format('YYYY-MM-DD  HH:mm:ss') : ''
      let end = time[1] ? this.$moment(time[1]).format('YYYY-MM-DD  HH:mm:ss') : ''
      this.query.createTimeStart = start
      this.query.createTimeEnd = end
    },
    async getpage(params) {
      // console.log(this.rangeTime)
      this.query.MaxResultCount = this.pageSize
      this.query.SkipCount = (this.currentPage - 1) * this.pageSize
      if (params === 1) {
        this.query.SkipCount = 0
      }
      this.loading = true
      const data = await this.$Ajax.get('/api/services/app/CustomerSettlementApiService/QueryDto', {
        params: this.query,
      })
      this.list = data.data.result.items
      this.totalCount = data.data.result.totalCount
      this.loading = false
    },
    pageChange(page) {
      this.currentPage = page
      this.getpage()
    },
    pagesizeChange(pagesize) {
      this.pageSize = pagesize
      this.getpage()
    },
	// 创建产品
	openCreateProduct(quotationId) {
	  this.quotationId = quotationId
	  this.createLogModelShow = true
	},
    reset() {
      this.query = {
        createTime: [],
        acceptanceDept: null,
        settlementMethods:null,
        createTimeStart: '',
        createTimeEnd: '',
        customerId: this.customerId,
      }
      this.getpage(1)
    },
  },
}
</script>
<style lang="less" scoped>
// /deep/.ivu-modal-fullscreen {
//   width: calc(~'100% - 256px') !important;
//   top: 0;
//   bottom: 0;
//   position: absolute;
//   left: 256px;
// }
</style>